@if (updatedRequirementsTableDesign) {
<form [formGroup]="noteForm">
  <div *ngIf="!baseProps.readonly">
    <shared-add-note-form
      [noteForm]="noteForm"
      [noteError]="noteError"
      [disabled]="disabled"
      [showVisibilityToggle]="isHiddenNoteFeatureEnabled && isHiddenNoteAccountSettingEnabled"
      visibilityIconButtonClass="mat-mdc-note-icon-button"
      placeholder="Add Note"
      (clearClicked)="clearNote()"
      (saveClicked)="addNote()"
      (visibilityToggled)="toggleNoteVisibility()">
    </shared-add-note-form>
  </div>
</form>
} @else {
<form [formGroup]="noteForm" [class.dropShadow]="props.dropShadow">
  <div class="add-note-form" *ngIf="!baseProps.readonly">
    <mat-form-field class="text-area-container textarea-formfield">
      <mat-label>Add Note</mat-label>
      <button mat-icon-button class="mat-mdc-note-icon-button" matPrefix
        [matTooltip]="noteForm.controls['isInternalNote'].value ? 'Hidden on case document' : 'Visible on case document'"
        formControlName="isInternalNote" (click)="toggleNoteVisibility()"
        *ngIf="isHiddenNoteFeatureEnabled && isHiddenNoteAccountSettingEnabled" [disabled]="disabled">
        <mat-icon>
          <ng-container *ngIf="!noteForm.controls['isInternalNote'].value">visibility</ng-container>
          <ng-container *ngIf="noteForm.controls['isInternalNote'].value">visibility_off</ng-container>
        </mat-icon>
      </button>
      <textarea matInput formControlName="note" cdkTextareaAutosize cdkAutosizeMaxRows="10"
        [disabled]="disabled"></textarea>
      <mat-error *ngIf="noteError">Note is required</mat-error>
    </mat-form-field>
    <div class="action-button-container">
      <button mat-flat-button style="background-color: transparent" (click)="clearNote()"
        [disabled]="disabled">Clear</button>
      <button mat-stroked-button color="primary" (click)="addNote()" [disabled]="disabled">Save Note</button>
    </div>
  </div>
</form>
}
